// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const tableOfContentsWrapper = "FAQ__tableOfContentsWrapper__3NTW1 ContentsBased__tableOfContentsWrapper__qIwdZ";
export const content = "FAQ__content__o+CWG";
export const emailSection = "FAQ__emailSection__J4T7W ContentsBased__section__2U6EQ font-faces__sansMedium__DqLMY font-faces__sans__uCf65";